'use client';

import { c as _c } from "react/compiler-runtime";
import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';
import { cn } from '@/lib/utils';

/** Track and thumb per size: 36×20 with a 16px thumb, or 28×16 with a 12px one. */
const SWITCH_SIZE_CLASSES = {
  default: {
    root: 'h-5 w-9',
    thumb: 'h-4 w-4 data-[state=checked]:translate-x-4'
  },
  sm: {
    root: 'h-4 w-7',
    thumb: 'size-3 data-[state=checked]:translate-x-3'
  }
} as const;
const Switch = t0 => {
  const $ = _c(17);
  let className;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? "default" : t1;
  const t2 = SWITCH_SIZE_CLASSES[size];
  let t3;
  if ($[5] !== className || $[6] !== t2.root) {
    t3 = cn("peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-xs transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-zinc-700/90", t2.root, className);
    $[5] = className;
    $[6] = t2.root;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = SWITCH_SIZE_CLASSES[size];
  let t5;
  if ($[8] !== t4.thumb) {
    t5 = cn("pointer-events-none block rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0", t4.thumb);
    $[8] = t4.thumb;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <SwitchPrimitives.Thumb className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== ref || $[14] !== t3 || $[15] !== t6) {
    t7 = <SwitchPrimitives.Root className={t3} {...props} ref={ref}>{t6}</SwitchPrimitives.Root>;
    $[12] = props;
    $[13] = ref;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
Switch.displayName = SwitchPrimitives.Root.displayName;
export { Switch };